import React, { useEffect, useState } from "react";
import Playlist from "../Component/Playlist/Playlist";
import "./Hero.css";
import WriteBlog from "./WriteBlog/WriteBlog";
const Hero = () => {
  const [ChannelInfo, setChannelInfo] = useState([]);
  useEffect(() => {
    fetch(
      "https://youtube.googleapis.com/youtube/v3/channels?part=snippet&id=UC49igY3A_M9__UL4_QUWTBA&key=AIzaSyBaQ3qRfrim14hAzutqHtPUR-Oq-_jhNSg"
    )
      .then((res) => res.json())
      .then((data) => setChannelInfo(data?.items[0]?.snippet));
  }, []);

  return (
    <>
      <div className="md:mx-40 md:my-20 flex flex-col  justify-center items-center md:gap-20 md:flex-row-reverse">
        <div className="mt-8 mockup-phone border-primary min-w-[350px] min-h-[600px]">
          <div className="camera"></div>
          <div className="display">
            <div className="artboard artboard-demo phone-1">
              <div className="hero bg-violet-700 pt-12">
                <div className="hero-content text-center pb-14">
                  <div className="flex flex-col items-center h-[450px]">
                    <img
                      width={"200px"}
                      className="mask mask-circle"
                      alt="Channel-logo"
                      src={ChannelInfo?.thumbnails?.medium?.url}
                    />
                    <h1 className="text-3xl font-bold text-white">
                      {ChannelInfo?.title}
                    </h1>
                    <p className=" text-gray-200 mb-3">
                      {ChannelInfo?.description?.slice(0, 200)}...
                    </p>
                    {/* ------------------------- */}

                    <div className="pt-2 pb-1 px-3 rounded-lg bg-white">
                      <div
                        className="g-ytsubscribe"
                        data-channelid="UC49igY3A_M9__UL4_QUWTBA"
                        data-layout="default"
                        data-count="default"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <img src={svg} alt="" /> */}
            </div>
          </div>
        </div>
        <div className="text-center lg:text-left py-10">
          <h3 className="text-2xl text-gray-500">Hyy there!</h3>
          <h1 className="md:text-7xl text-4xl font-bold text-gray-800">
            I'm Hasan Uddin Rimon
          </h1>
          <p className="md:py-6 md:px-3 px-5 md:px-2 text-gray-500">
            I provide latest technology news, reviews, and tutorials. From
            smartphones and laptops to gaming and AI, I cover it all. My goal is
            to help you make informed decisions about the products you use. I
            also make sure to explain complex tech topics in an easy to
            understand way. So whether you're a tech expert or just getting
            started, my channel has something for you. Don't forget to subscribe
            for new videos every week and follow me on social media for more
            tech content. Thank you for visiting my website!
          </p>
        </div>
      </div>

      {/* ---------------------------- */}

      <div className="flex flex-col w-3/4 lg:flex-row my-10 mx-auto gap-8">
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-violet-700 font-semibold text-2xl text-white">
          Technologies
        </div>
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-fuchsia-700 font-semibold text-2xl text-white">
          Information
        </div>
        <div className="grid flex-grow h-32 card  rounded-box place-items-center bg-indigo-700 font-semibold text-2xl text-white">
          Security
        </div>
      </div>
      <WriteBlog></WriteBlog>
      <Playlist></Playlist>
      {/* <Videos></Videos> */}
    </>
  );
};

export default Hero;
